export default __webpack_public_path__ + "static/media/bihada-factory-mission-08.93e4527e.jpg";